import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ENDPOINTS } from '../../constants/endpoints.constants';

@Injectable({
  providedIn: 'root',
})
export class SaasService {
  private readonly http = inject(HttpClient);

  saasConfig(): Observable<SaasConfigResponse> {
    const url = ENDPOINTS.Saas.Config;
    return this.http.get<SaasConfigResponse>(url);
  }
}

export interface SaasConfigResponse {
  data: SaasConfig;
}

export interface SaasConfig {
  enabled_modules: string[];
}
